export { default } from './ContentSubtitle';
